import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-training-videos',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './training-videos.component.html',
  styleUrls: ['./training-videos.component.scss']
})
export class TrainingVideosComponent {
  videos: { title: string; videoId: string }[] = [
    { title: 'Talos T60X and DJI T100 Remote Overview', videoId: '9bhL4saR7nA' },
    { title: 'DJI T100 Nozzle Solenoid Assembly', videoId: 'jHTr6GNWV-A' },
    { title: 'DJI T100 Motor Assembly', videoId: 'oZ0bA7BE7tY' },
    { title: 'DJI T100 Nozzle Motor Disassembly', videoId: '2rabkYXzFFQ' },
    { title: 'DJI T100 Nozzle Motor Assembly', videoId: 'PwUA9iG-RVY' },
    { title: 'DJI T100 ESC Disassembly', videoId: 'bj6sXZjomDs' },
    { title: 'DJI T100 ESC Assembly', videoId: '7lWq-fyOcAs' },
    { title: 'DJI T100 Motor Removal', videoId: '_O9cViD0xxc' },
    { title: 'Revolution I-19 Propeller Removal', videoId: 'd0ThDr7Aj7s' },
    { title: 'Revolution I-19 Propeller Install', videoId: 'e3cvmFzV5NQ' },
    { title: 'Revolution I-19 Du Clip Removal', videoId: '1j0HmJhIH1g' },
    { title: 'Revolution I-19 Du Clip Install', videoId: 'ZIU-IwNsCto' },
  ];
  activeVideo: { title: string; embedUrl: SafeResourceUrl } | null = null;

  constructor(private sanitizer: DomSanitizer) {}

  getEmbedUrl(videoId: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube.com/embed/${videoId}?autoplay=1`
    );
  }

  openVideo(video: { title: string; videoId: string }): void {
    this.activeVideo = { title: video.title, embedUrl: this.getEmbedUrl(video.videoId) };
  }

  closeVideo(): void {
    this.activeVideo = null;
  }
}
